module.exports = __webpack_public_path__ + "img/down.f09d3e01.png";